export default __webpack_public_path__ + "static/media/offer-img.101d9fe6.svg";